export default __webpack_public_path__ + "static/media/logo.ddbcbc3c.png";